<template>

  <v-list-item>
    <v-list-item-content class="py-1">
      <v-list-item-title>
        {{ share.email }} 
        <!--<span class="text-body-2">({{ share.roleDescription }})</span>-->
      </v-list-item-title>
      <v-list-item-subtitle>
        {{$t('orders.share_expires_at')}}: {{ $formatDateNoTime(share.expiresAt) }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon><hb-icon>more_vert</hb-icon></v-btn>
        </template>
        <v-list dense class="pa-0">
          <v-list-item @click="editClicked"  :disabled="$isImpersonating">
            <v-list-item-avatar><v-icon>edit</v-icon></v-list-item-avatar>
            <v-list-item-title>{{ $t('orders.edit_share')}}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteClicked"  :disabled="$isImpersonating">
            <v-list-item-avatar><v-icon>delete</v-icon></v-list-item-avatar>
            <v-list-item-title>{{ $t('orders.delete_share')}}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="() => {}">
            <v-list-item-avatar>
              <v-icon>close</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>{{ $t('close_menu') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>

  </v-list-item>
</template>

<script>
export default {
  name: 'ShareOrderShareRow',
  props: ['share'],
  emits: ['click:delete', 'click:edit'],
  methods: {
    deleteClicked() {
      this.$emit('click:delete', this.share);
    },
    editClicked() {
      this.$emit('click:edit', this.share);
    }
  }
}
</script>

<style scoped>

</style>